module.exports = __webpack_public_path__ + "static/media/Schritt_4_Bitte_an_den_Kollegen_Milo.36de759e.pdf";